import SbNote from "domain/sb_note.class";

export default class DeliverableNotesFilter {
    constructor() {
        this.options = [
            {
                text: "_OPEN_CLAIMS",
                type: SbNote.TYPE_QUALITY_ISSUE_ENUM,
                closed: false,
                iconClasses: "sb-icon sb-icon-status_alert sb-claim",
            },
            {
                text: "_OPEN_OBSTRUCTIONS",
                type: SbNote.TYPE_OBSTRUCTION_ENUM,
                closed: false,
                iconClasses: "sb-icon sb-icon-status-problem sb-obstruction",
            },
            {
                text: "_CLOSED_CLAIMS",
                type: SbNote.TYPE_QUALITY_ISSUE_ENUM,
                closed: true,
                iconClasses: "sb-icon sb-icon-status_alert sb-issue-closed",
            },
            {
                text: "_CLOSED_OBSTRUCTIONS",
                type: SbNote.TYPE_OBSTRUCTION_ENUM,
                closed: true,
                iconClasses: "sb-icon sb-icon-status-problem sb-issue-closed",
            },
            {
                text: "_INFO_S",
                type: SbNote.TYPE_INFO_ENUM,
                iconClasses: "sb-icon sb-icon-status_info sb-info",
            },
        ].map((option) => ({ ...option, selected: false, value: 0 }));
    }

    updateSummary(summary) {
        const values = [
            summary.claims.open,
            summary.obstructions.open,
            summary.claims.closed,
            summary.obstructions.closed,
            summary.infos.total,
        ];
        this.options.forEach((option, index) => {
            option.value = values[index];
        });
        return this.options;
    }

    toggle(option) {
        option.selected = !option.selected;
    }

    apply(notes) {
        const selected = this.options.filter((option) => option.selected);
        if (selected.length === 0) {
            return notes;
        }
        return notes.filter((note) =>
            selected.some(
                (option) =>
                    note.ISSUE_TYPE === option.type &&
                    (option.type === SbNote.TYPE_INFO_ENUM ||
                        option.closed ===
                            SbNote.isFinished({
                                type: note.ISSUE_TYPE,
                                state: note.ISSUE_STATUS,
                            }))
            )
        );
    }
}
